//*****************************************************************************
// Axios invia un record a MongoDB con postMongo.php
//*****************************************************************************
const OnePutDB = async (oneRecord) => {
  const axios = require('axios');
  console.log(oneRecord);
  try {
    const response = await axios({
      method: 'POST',
      url: 'https://web.dida.unifi.it/parole_ricerca/postMongo.php',
      data: JSON.stringify(oneRecord),

    });

    console.log("salvato");
    console.log(response.statusText);



  } catch (error) {
    console.log('ERRORE nel POST');
    console.error(error);
  }
};

export default OnePutDB;
